import React from "react";

export default (props: React.SVGAttributes<SVGElement>) => <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
<path d="M0 13.2C0 12.9184 0.107387 12.637 0.322231 12.4222C0.751781 11.9926 1.44829 11.9926 1.87784 12.4222L20.9 31.4443L39.9222 12.4222C40.3518 11.9926 41.0483 11.9926 41.4778 12.4222C41.9074 12.8518 41.9075 13.5482 41.4778 13.9778L21.6778 33.7778C21.2483 34.2074 20.5518 34.2074 20.1222 33.7778L0.322231 13.9778C0.107387 13.763 0 13.4815 0 13.2H0Z" fill="black"/>
</svg>
;
